import { render, staticRenderFns } from "./user-permissions.vue?vue&type=template&id=79a9e1fe&scoped=true"
import script from "./user-permissions.vue?vue&type=script&lang=js"
export * from "./user-permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9e1fe",
  null
  
)

export default component.exports